// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31tXd","toggle":"styles_toggle__2U28E","preview":"styles_preview__2B_Wo"};